import { useBreakpointValue } from 'native-base';
import React from 'react';

import { FundOfferEntityNormalized } from '../../../../../../../../../store/product/types';
import { FundsAssetProvider } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/Funds';
import { ItemDetails } from '../Details';

import { FundsListItemDesktop } from './desktop';
import { FundsListItemMobile } from './mobile';
import { FundsListItemTablet } from './tablet';

export namespace FundsListItemTypes {
  export interface Props {
    offer: FundOfferEntityNormalized;
  }
}

export const FundsListItem: React.FC<FundsListItemTypes.Props> = ({ offer }) => {
  const FundsListItemResponsive = useBreakpointValue({
    base: <FundsListItemMobile offer={offer} />,
    sm: <FundsListItemTablet offer={offer} />,
    lg: <FundsListItemDesktop offer={offer} />,
  });

  return (
    <FundsAssetProvider>
      <ItemDetails />
      {FundsListItemResponsive}
    </FundsAssetProvider>
  );
};
